/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const cornerFillerComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'cornerCabinet', true).withEntity('CornerFiller').withFilter((s)=>s.$cornerFillerFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_LYNX-BCC-28252825',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'countertopPartOne', true).withEntity('CornerFiller').withFilter((s)=>s.$cornerFillerCountertopFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'COUNTERTOP',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'countertopPartTwo', true).withEntity('CornerFiller').withFilter((s)=>s.$cornerFillerCountertopFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'COUNTERTOP',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'backPanelPartOne', true).withEntity('CornerFiller').withFilter((s)=>s.$backPanelPartOneFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'REAR_PANEL',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'backPanelPartTwo', true).withEntity('CornerFiller').withFilter((s)=>s.$backPanelPartTwoFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'REAR_PANEL',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'toeKickPartOne', true).withEntity('CornerFiller').withFilter((s)=>s.$cornerFillerFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'TOE_KICK',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'toeKickPartTwo', true).withEntity('CornerFiller').withFilter((s)=>s.$cornerFillerFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'TOE_KICK',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'default', true).withEntity('CornerFiller').attach(memoEval((self)=>[
            self.$offsetX,
            self.$offsetY,
            self.$offsetZ,
            self.$rotation
        ], ($offsetX, $offsetY, $offsetZ, $rotation)=>({
            offsetX: $offsetX,
            offsetY: $offsetY,
            offsetZ: $offsetZ,
            rotationY: $rotation
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'countertopPartOne', true).withEntity('CornerFiller').attach(memoEval((self)=>[
            self.$countertopPartOneOffsetX,
            self.$countertopPartOneOffsetZ,
            self.$countertopPartOneWidth,
            self.$countertopScaleZero,
            self.$countertopScaleOne,
            self.$countertopPartOneDepth,
            self.$countertopDepthScaleZero,
            self.$countertopDepthScaleOne
        ], ($countertopPartOneOffsetX, $countertopPartOneOffsetZ, $countertopPartOneWidth, $countertopScaleZero, $countertopScaleOne, $countertopPartOneDepth, $countertopDepthScaleZero, $countertopDepthScaleOne)=>({
            offsetX: $countertopPartOneOffsetX,
            offsetZ: $countertopPartOneOffsetZ,
            morphTargetInfluences: {
                Width: {
                    value: $countertopPartOneWidth,
                    scaleZero: $countertopScaleZero,
                    scaleOne: $countertopScaleOne
                },
                Depth: {
                    value: $countertopPartOneDepth,
                    scaleZero: $countertopDepthScaleZero,
                    scaleOne: $countertopDepthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'countertopPartTwo', true).withEntity('CornerFiller').attach(memoEval((self)=>[
            self.$countertopPartTwoOffsetX,
            self.$countertopPartTwoOffsetZ,
            self.$countertopPartTwoWidth,
            self.$countertopScaleZero,
            self.$countertopScaleOne,
            self.$countertopPartTwoDepth,
            self.$countertopDepthScaleZero,
            self.$countertopDepthScaleOne
        ], ($countertopPartTwoOffsetX, $countertopPartTwoOffsetZ, $countertopPartTwoWidth, $countertopScaleZero, $countertopScaleOne, $countertopPartTwoDepth, $countertopDepthScaleZero, $countertopDepthScaleOne)=>({
            offsetX: $countertopPartTwoOffsetX,
            offsetZ: $countertopPartTwoOffsetZ,
            morphTargetInfluences: {
                Width: {
                    value: $countertopPartTwoWidth,
                    scaleZero: $countertopScaleZero,
                    scaleOne: $countertopScaleOne
                },
                Depth: {
                    value: $countertopPartTwoDepth,
                    scaleZero: $countertopDepthScaleZero,
                    scaleOne: $countertopDepthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'backPanelPartOne', true).withEntity('CornerFiller').attach(memoEval((self)=>[
            self.$backPanelPartOneOffsetX,
            self.$backPanelPartOneOffsetZ,
            self.$backPanelPartOneRotationY,
            self.$backPanelPartOneWidth,
            self.$backPanelWidthScaleZero,
            self.$backPanelWidthScaleOne
        ], ($backPanelPartOneOffsetX, $backPanelPartOneOffsetZ, $backPanelPartOneRotationY, $backPanelPartOneWidth, $backPanelWidthScaleZero, $backPanelWidthScaleOne)=>({
            offsetX: $backPanelPartOneOffsetX,
            offsetZ: $backPanelPartOneOffsetZ,
            rotationY: $backPanelPartOneRotationY,
            morphTargetInfluences: {
                Width: {
                    value: $backPanelPartOneWidth,
                    scaleZero: $backPanelWidthScaleZero,
                    scaleOne: $backPanelWidthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'backPanelPartTwo', true).withEntity('CornerFiller').attach(memoEval((self)=>[
            self.$backPanelPartTwoOffsetX,
            self.$backPanelPartTwoOffsetZ,
            self.$backPanelPartTwoRotationY,
            self.$backPanelPartTwoWidth,
            self.$backPanelWidthScaleZero,
            self.$backPanelWidthScaleOne
        ], ($backPanelPartTwoOffsetX, $backPanelPartTwoOffsetZ, $backPanelPartTwoRotationY, $backPanelPartTwoWidth, $backPanelWidthScaleZero, $backPanelWidthScaleOne)=>({
            offsetX: $backPanelPartTwoOffsetX,
            offsetZ: $backPanelPartTwoOffsetZ,
            rotationY: $backPanelPartTwoRotationY,
            morphTargetInfluences: {
                Width: {
                    value: $backPanelPartTwoWidth,
                    scaleZero: $backPanelWidthScaleZero,
                    scaleOne: $backPanelWidthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'toeKickPartOne', true).withEntity('CornerFiller').attach(memoEval((self)=>[
            self.$toeKickPartOneOffsetX,
            self.$toeKickPartOneOffsetZ,
            self.$toeKickPartOneRotationY,
            self.$toeKickPartOneWidth,
            self.$toeKickWidthScaleZero,
            self.$toeKickWidthScaleOne,
            self.$toeKickPartOneDepth,
            self.$toeKickDepthScaleZero,
            self.$toeKickDepthScaleOne
        ], ($toeKickPartOneOffsetX, $toeKickPartOneOffsetZ, $toeKickPartOneRotationY, $toeKickPartOneWidth, $toeKickWidthScaleZero, $toeKickWidthScaleOne, $toeKickPartOneDepth, $toeKickDepthScaleZero, $toeKickDepthScaleOne)=>({
            offsetX: $toeKickPartOneOffsetX,
            offsetZ: $toeKickPartOneOffsetZ,
            rotationY: $toeKickPartOneRotationY,
            morphTargetInfluences: {
                Width: {
                    value: $toeKickPartOneWidth,
                    scaleZero: $toeKickWidthScaleZero,
                    scaleOne: $toeKickWidthScaleOne
                },
                Depth: {
                    value: $toeKickPartOneDepth,
                    scaleZero: $toeKickDepthScaleZero,
                    scaleOne: $toeKickDepthScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'toeKickPartTwo', true).withEntity('CornerFiller').attach(memoEval((self)=>[
            self.$toeKickPartTwoOffsetX,
            self.$toeKickPartTwoOffsetZ,
            self.$toeKickPartTwoRotationY,
            self.$toeKickPartTwoWidth,
            self.$toeKickWidthScaleZero,
            self.$toeKickWidthScaleOne,
            self.$toeKickPartTwoDepth,
            self.$toeKickDepthScaleZero,
            self.$toeKickDepthScaleOne
        ], ($toeKickPartTwoOffsetX, $toeKickPartTwoOffsetZ, $toeKickPartTwoRotationY, $toeKickPartTwoWidth, $toeKickWidthScaleZero, $toeKickWidthScaleOne, $toeKickPartTwoDepth, $toeKickDepthScaleZero, $toeKickDepthScaleOne)=>({
            offsetX: $toeKickPartTwoOffsetX,
            offsetZ: $toeKickPartTwoOffsetZ,
            rotationY: $toeKickPartTwoRotationY,
            morphTargetInfluences: {
                Width: {
                    value: $toeKickPartTwoWidth,
                    scaleZero: $toeKickWidthScaleZero,
                    scaleOne: $toeKickWidthScaleOne
                },
                Depth: {
                    value: $toeKickPartTwoDepth,
                    scaleZero: $toeKickDepthScaleZero,
                    scaleOne: $toeKickDepthScaleOne
                }
            }
        })))
];

//# sourceMappingURL=corner-filler.js.map